import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import CheckListConstants from "../Constants/CheckListInspectionConstant";
class CheckListInspection_Action {
  getAnlageCheckList(anlageId) {
    httpRequest(
      config.webServiceURL + "/Checklist/GetAnlageChecklists/" + anlageId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CheckListConstants.GET_ANLAGE_CHECKLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CheckListConstants.GET_ANLAGE_CHECKLIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getCheckListDetails(CheckListId) {
    httpRequest(
      config.webServiceURL + "/Checklist/GetChecklist/" + CheckListId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CheckListConstants.GET_CHECKLIST_DETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CheckListConstants.GET_CHECKLIST_DETAILS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveInspection(inspectionData) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/SaveInspection/",
      "POST",
      JSON.stringify({
        ...inspectionData,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CheckListConstants.SAVE_INSPECTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CheckListConstants.SAVE_INSPECTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new CheckListInspection_Action();
